import React from 'react';
import { Box, Button, Divider, Paper, TextField } from '../../../elements';
import { Container, Title } from './Step.style';
import { t } from '../../../../../js/common/translations';

const StepOne = ({ handleSetStep, visitForm, setVisitForm, getErrorMessage }) => {
  return (
    <Container>
      <Paper sx={{ padding: '24px', maxWidth: { xs: '100%', md: '575px' }, width: '100%' }}>
        <Box>
          <Title sx={{ mb: '2rem' }}>{t('visit_form.step_one.title')}</Title>
          <Box display="flex" sx={{ flexDirection: 'column' }}>
            <TextField
              value={visitForm.visitor_fullname}
              onChange={setVisitForm('visitor_fullname')}
              sx={{ mb: 1 }}
              label={t('visit_form.step_one.full_name')}
              error={!!getErrorMessage('visitor_fullname')}
              helperText={getErrorMessage('visitor_fullname')}
            />
            <TextField
              value={visitForm.visitor_phone_number}
              onChange={setVisitForm('visitor_phone_number')}
              sx={{ mb: 1 }}
              label={t('visit_form.step_one.phone_number')}
              error={!!getErrorMessage('visitor_phone_number')}
              helperText={getErrorMessage('visitor_phone_number')}
            />
            <TextField
              error={!!getErrorMessage('visitor_email')}
              helperText={getErrorMessage('visitor_email')}
              value={visitForm.visitor_email}
              onChange={setVisitForm('visitor_email')}
              sx={{ mb: 1 }}
              label={t('visit_form.step_one.email')}
            />
          </Box>
          <Divider />
          <Box display="flex" sx={{ mt: '24px' }}>
            <Button
              size="large"
              href="javascript:window.history.back();"
              variant='outlined'
              sx={{ width: '100%', mr: '0.75rem' }}
            >
              {t('visit_form.back_button')}
            </Button>
            <Button
              size="large"
              sx={{ width: '100%', ml: '0.75rem' }}
              onClick={() => handleSetStep({ step: 'two' })}
            >
              {t('visit_form.step_one.choose_day_time')}
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default StepOne;
